import { Container, Row } from "reactstrap";
import ButtonAddons from "./ButtonAddons";
import { FormControlsTitle, InputGroupTitle } from "../../../../../constants";
import CustomForms from './customForms'
import CustomFileInput from './CustomFileInput'
import ButtonsWithDropdowns from './buttonsWithDropdowns'
import SegmentedButtons from './SegmentedButtons'
import CheckboxesAndRadios from './CheckboxesAndRadios'
import Sizing from './Sizing'
import MultipleInputs from './MultipleInputs'
import BasicInputGroups from './BasicInputGroups'
import VariationAddons from './variationAddons'
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const InputGroupsContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={InputGroupTitle} parent={FormControlsTitle} />
      <Container fluid>
        <Row>
          <ButtonAddons />
          <CustomForms/>
          <CustomFileInput/>
          <ButtonsWithDropdowns/>
          <SegmentedButtons/>
          <CheckboxesAndRadios/>
          <Sizing/>
          <MultipleInputs/>
          <BasicInputGroups/>
          <VariationAddons/>
        </Row>
      </Container>
    </>
  );
};
export default InputGroupsContainer;
